
import { useTranslation } from 'react-i18next';

export default function CoreValues() {
  const { t } = useTranslation();

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: t('values.ethics.title'),
      description: t('values.ethics.text'),
    },
    {
      icon: 'ri-lightbulb-line',
      title: t('values.wisdom.title'),
      description: t('values.wisdom.text'),
    },
    {
      icon: 'ri-hand-heart-line',
      title: t('values.service.title'),
      description: t('values.service.text'),
    },
    {
      icon: 'ri-global-line',
      title: t('values.impact.title'),
      description: t('values.impact.text'),
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-[#F8F9FA] to-[#E9ECEF]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-4">
            {t('values.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('values.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#C9A961] to-[#B89851] rounded-full flex items-center justify-center mb-6">
                <i className={`${value.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A2332] mb-3">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
